import isNumber from 'lodash/isnumber';
import { CodeActionType, CodeItemWire } from 'app/area/codetable/item/types';
import { AccessCodes } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { substanceUomSetType } from 'app/area/codetable/item/codetable-item-helpers';
import { CodeListItemWire } from 'app/area/codetable/common';
import { defaultUomConversionFactor } from 'app/area/codetable/item/constants';

export const mapCodeItemSubset = (codeItemWire: CodeItemWire, accessCodes: AccessCodes): CodeItemWire => {
  if (!codeItemWire || typeof codeItemWire !== 'object') {
    return undefined;
  }

  return accessCodes && !accessCodes.edit && (codeItemWire && codeItemWire.subset) ? {
    ...codeItemWire,
    ...(codeItemWire.subset && codeItemWire.subset.length > 0 && {
      subset: codeItemWire.subset
        .map(element => accessCodes.readonlySubsets
          && (accessCodes.readonlySubsets.includes(element.v))
          ? { ...element, readOnly: true }
          : element)
    })
  } : codeItemWire;
};

export const mapSubstanceUomSet = (codetableId: number, codeItemWire: CodeItemWire): CodeItemWire => {
  if (!codetableId || !codeItemWire || typeof codeItemWire !== 'object') {
    return undefined;
  }

  const key = substanceUomSetType(codetableId);
  const { [key]: propValue, ...rest } = codeItemWire;

  return (key && codeItemWire && codeItemWire[key]) ? {
    ...rest,
    ...(codeItemWire[key] && {
      substanceUomSet: codeItemWire[key]
    })
  } : codeItemWire;
};

export const mapCodeUomSets = (
  codeItem: CodeItemWire,
  options: CodeComplexValue<number>[] = []
): CodeItemWire => {
  const mappedOptions = options.map(code => ({ uomSet: { v: code?.value, d: code?.description } }));
  const filteredOptions = mappedOptions.filter(option =>
    !codeItem?.substanceUomSet?.map(uomSet => uomSet?.uomSet?.v).includes(option?.uomSet?.v));
  const substanceUomSet = codeItem?.substanceUomSet?.concat(filteredOptions);

  return Array.isArray(codeItem?.substanceUomSet)
    ? {
      ...codeItem,
      substanceUomSet
    } : codeItem;
};

export const mapCodeItemAccess = (codeId: number, accessCodes: AccessCodes[]) => {
  const codeAccessForCodeItem = !!accessCodes
    && Array.isArray(accessCodes) && accessCodes.find(codeAccess => codeAccess.id === codeId) || {} as any;
  const { edit, move, readonlySubsets } = codeAccessForCodeItem;

  return {
    ...(isNumber(codeId) && isDefinedIncludingZero(codeId) && { id: codeId }),
    ...(edit && { edit }),
    ...(move && { move }),
    ...(codeAccessForCodeItem.delete && { delete: codeAccessForCodeItem.delete }),
    ...(readonlySubsets && Array.isArray(readonlySubsets) && readonlySubsets.length > 0 && { readonlySubsets })
  };
};

export const mapUomConversionFactors = (
  id: number,
  actionType: CodeActionType,
  wireFactors: CodeListItemWire[],
  initialFactors: CodeComplexValue<number>[]
) => wireFactors?.map(item => {

  const isUomFrom = id === item?.code?.v;
  const isDuplicate = isUomFrom && actionType === CodeActionType.Duplicate;
  const initialValue = initialFactors?.find(c => c?.value === item?.code?.v)?.factor;
  const defaultValue = isUomFrom ? defaultUomConversionFactor : undefined;
  const factorValue = initialValue ?? defaultValue;

  return { value: item?.code?.v, description: item?.code?.d, factor: isDuplicate ? undefined : factorValue };
}) ?? [];
